import { useState, useCallback } from 'react';

export type FormMode = 'browse' | 'add' | 'edit';

export function usePWP211Mode() {
  const [mode, setMode] = useState<FormMode>('browse');

  const isEditing = mode === 'add' || mode === 'edit';

  const startAdd = useCallback(() => setMode('add'), []);
  const startEdit = useCallback(() => setMode('edit'), []);
  const toBrowse = useCallback(() => setMode('browse'), []);

  return { mode, setMode, isEditing, startAdd, startEdit, toBrowse };
}
